import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getCurrentWorkoutExerciseIndexStartWorkoutSelect from '../get-current-workout-exercise-index'
import getCurrentWorkoutSectionStartWorkoutSelect from '../get-current-workout-section'
import { WORKOUT_EXERCISES_PATH } from '../../../workout-exercise/redux/constants'
import getWorkoutExercisesWorkoutSectionUtil from '../../../workout-section/model/utils/get-workout-exercises'
import { createSelector } from 'reselect'
import { getObjectUtil } from 'packages/src'

const getCurrentWorkoutExerciseStartWorkoutSelect = createSelector(
  state => getObjectUtil(state, WORKOUT_EXERCISES_PATH.DATA),
  getCurrentWorkoutSectionStartWorkoutSelect,
  getCurrentWorkoutExerciseIndexStartWorkoutSelect,
  (workoutExercisesDomainMap, workoutSection, curWorkoutExerciseIndex) => {
    if (!workoutSection) {
      return
    }
    const workoutExercisePointers = getWorkoutExercisesWorkoutSectionUtil(
      workoutSection)
    const curWorkoutExercisePointer = workoutExercisePointers[curWorkoutExerciseIndex]
    if (!curWorkoutExercisePointer) {
      return workoutExercisePointers[workoutExercisePointers.length - 1]
    }
    const dMapVal = getIdReduxUtil(curWorkoutExercisePointer)
    return workoutExercisesDomainMap[dMapVal]
  }
)

export default getCurrentWorkoutExerciseStartWorkoutSelect
